/** @format */

/**
 * Microsoft Clarity Service
 * Session recordings, heatmaps - script loaded in index.html
 * This module verifies Clarity is running and logs initialization status
 */

declare global {
  interface Window {
    clarity?: (command: string, ...args: any[]) => void;
  }
}

const CLARITY_PROJECT_ID = 'vpf18ds0c0';
const CLARITY_DEBUG_MODE = process.env.NODE_ENV === 'development';

export const isClarityAvailable = (): boolean => {
  return typeof window !== 'undefined' && typeof window.clarity === 'function';
};

const checkAndLogClarity = (attempt: number = 0): void => {
  const maxAttempts = 5;
  const delayMs = 500;

  if (isClarityAvailable()) {
    console.log('✅ Microsoft Clarity initialized:', CLARITY_PROJECT_ID);
    return;
  }

  if (attempt < maxAttempts) {
    setTimeout(() => checkAndLogClarity(attempt + 1), delayMs);
  } else if (CLARITY_DEBUG_MODE) {
    console.warn('Microsoft Clarity: Script not loaded after', maxAttempts, 'attempts. Check index.html.');
  }
};

/**
 * Initialize / verify Microsoft Clarity is running
 * Clarity script loads async in index.html - we poll until it's available
 */
export const initializeClarity = (): void => {
  if (typeof window === 'undefined') return;

  window.addEventListener('load', () => {
    checkAndLogClarity(0);
  });

  // Also check immediately in case load already fired
  if (document.readyState === 'complete') {
    checkAndLogClarity(0);
  }
};

const clarityService = {
  initializeClarity,
  isClarityAvailable,
};

export default clarityService;
